import React from "react";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";
import { useDispatchWrapper } from "../../hooks";
import { outlookConnectStatus } from "../../redux/outlook/outlookThunk";
import { IEmailWrapperProps } from "./EmailWrapper.types";

export const EmailWrapper: React.FC<IEmailWrapperProps> = ({ children }) => {
  const { user } = useAuth();
  const dispatch = useDispatchWrapper();

  React.useEffect(() => {
    if (user.isLogin) {
      dispatch(outlookConnectStatus({}));
    }
  }, [dispatch, user.isLogin]);

  return <>{children}</>;
};
